export class NativeStreamSchemaColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamSchemaColumnType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamSchemaColumn.attributeTypeMap;
    }
    constructor() {
    }
}
